<template lang="pug">
v-main
  v-container(fluid)
    v-overlay(:value="!allReady", opacity="0.7")
      v-progress-circular(indeterminate, size="64")
    div(style="display: flex;justify-content: space-between;padding: 1rem;background: white;padding-bottom: .2rem;")
      p(style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") Edit Memo Payment Request
      v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO
    v-dialog(v-model='dialogInactiveBank' persistent='' max-width='400')
      v-card
        v-card-title(style="display: flex; justify-content: center; font-size:40px;")
          v-icon.mr-2(
            style="margin-top:1rem; font-size:40px;"
            title="edit",
            color="orange",
          )
            | error
        v-card-text(style="font-size:16px; text-align: center;margin-top:1rem")
          h2(style="color:black; margin:1rem") Information
          | The data bank has been updated. Please select the bank name again
        v-card-actions(style="justify-content: center;")
          v-btn(style="background: #1976D2; color: white; margin-bottom:1rem; width:80%" text='' @click='dialogInactiveBank = false')
            | OK
    
    v-dialog(v-model='dialogInactiveApprover' persistent='' max-width='370')
      v-card
        v-card-title(style="display: flex; justify-content: center; font-size:40px;")
          v-icon.mr-2(
            style="margin-top:1rem; font-size:40px;"
            title="edit",
            color="red",
            @click="onEdit(item.id, item.user_id)"
          )
            | error
        v-card-text(style="font-size:16px; text-align: center;margin-top:1rem")
          | {{ errorActiveUserMsg}}
        v-card-actions(style="justify-content: center;")
          v-btn(style="background: #1976D2; color: white; margin-bottom:1rem; width:80%" text='' @click='dialogInactiveApprover = false')
            | OK
    v-stepper(v-model="e1" :disabled="formDisabled")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1")
          | Memo Details
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Payment Details
        v-divider
        v-stepper-step(step="3") Approval
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-2(style="box-shadow: none")
            //- | HALAMAN `1`
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    v-subheader(color="black")
                      | &nbsp;Business Unit&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      style="padding: 0",
                      label="Select Business Unit",
                      id="imPaySelectBU"
                      :items="myBuList",
                      :disabled="tempDataPaymentL.imStatus != 1",
                      item-text="label",
                      item-value="value",
                      v-model="imPayDataSelectedBU",
                      placeholder="Select",
                      required
                      @change="trigerChange"
                    )
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Subject&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      style="padding: 0",
                      label="Subject",
                      id="imPaySubject"
                      v-model="imPayDataPurpose"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Invoice No&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-text-field(
                      style="padding: 0",
                      id="imPayInvoiceNo"
                      label="Invoice No",
                      v-model="imPayDataInvoiceNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Invoice Date&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-menu(
                      v-model="pickerStyle"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto")
                    
                      template(v-slot:activator="{ on, attrs }")
                        v-text-field(
                          v-model="imPayDataInvoiceDate"
                          id="imPayInvoiceDate"
                          label="Select Invoice Date"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on")
                        
                      v-date-picker(
                        v-model="imPayDataInvoiceDate"
                        @input="pickerStyle = false")

                      //- v-text-field(
                      //-   style="padding: 0",
                      //-   label="Invoice Date",
                      //-   v-model="imPayDataInvoiceDate"
                      //- )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Tax No&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-text-field(
                      id="imPayTaxNo"
                      style="padding: 0",
                      label="Tax No",
                      v-model="imPayDataTaxNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Purpose&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayPurpose"
                      style="padding: 0",
                      label="Purpose",
                      v-model="imPayDataTujuan"
                    )

                v-row
                  v-col(cols="3") 
                    v-subheader(color="black")
                      span(style="font-size: 16px; font-weight: 600") Attachment File
                  v-col(cols="8")
                    v-flex(xs12, sm6, md12, mb-2)
                      div.mt-1(style="font-size: 14px") 
                        input#file(
                          v-if="fileName.length > 0",
                          type="file",
                          ref="fileadd",
                          style="display: none",
                          v-on:change="addFile()",
                          accept=".7z, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length > 0",
                          outlined,
                          color="primary",
                          @click="$refs.fileadd.click()"
                        ) 
                          v-icon add
                          | Add file
                        input#file(
                          v-if="fileName.length == 0",
                          type="file",
                          ref="file",
                          style="display: none",
                          v-on:change="uploadLampiran()",
                          accept=".pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length == 0",
                          outlined,
                          color="primary",
                          @click="$refs.file.click()"
                        ) 
                          v-icon add
                          | Add file
                        p.mt-1 Max Size: 5 MB. Allowed: .pdf, .doc, .zip, .7zip, .rar,  .docx, .xlsx, .xls, or images
                        v-alert.mt-2(
                          v-model="uploadAlert",
                          color="red",
                          dense,
                          text,
                          dismissible
                        ) The file is too big. Max file size 5 MB
                        v-spacer.mt-2
                        //- b(style="font-size:14px; font-weight: 600;") total files: {{fileName.length}}
                        v-row.mt-1
                          v-chip.ma-2(
                            v-if="fileName.length > 0",
                            v-for="(item, index) in fileName",
                            :key="item",
                            close
                            @click:close="removeLampiran(item, index)" 
                          )
                            span(v-if="item.name != null") {{ item.name | truncate(15, '...') }}
                            span(v-else) {{ item | truncate(15, '...') }}

                v-subheader(style="color: #000;font-family: Roboto;font-size: 16px;font-style: normal;font-weight: 600;line-height: normal;") &nbsp;Pay To&nbsp;
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Name&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      id="imPayBankName"
                      style="padding: 0",
                      label="Select Bank",
                      :items="masterBank",
                      :filter="customFilter"
                      item-title="text",
                      v-model="imPayDataBankName", 
                      placeholder="Select Bank Name",
                      required
                    )
                      template(v-slot:item="data")
                        p {{data.item.text}}

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Account No&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayBankNo"
                      @keypress="numberOnly(event)"
                      @paste="disablePaste"
                      style="padding: 0",
                      label="Bank Account No",
                      v-model="imPayDataBankNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Account Name&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayBankAccountName"
                      style="padding: 0",
                      label="Bank Account Name",
                      v-model="imPayDataPayTo"
                    )
                
          v-btn(depressed, large, id="imPayPage1Cancel" style="background-color: #f5f5f5;" text="" @click="$router.push('/my-request')") Cancel
          v-btn(depressed, large, id="imPayPage1Next" style="margin: 0.6rem" :disabled="form1Validation || !allReady" color="primary", @click="e1 = 2") Next
        v-stepper-content(step="2")
          v-dialog(v-model='dialogChangeCurency' max-width='400')
            v-card
              v-card-title.text-h5
                | Confirm Currency Change ?
              v-card-text
                | To prevent errors in the total payment due to difference in currency format, the item list will be left blank
              v-card-actions()
                v-spacer
                div(style="display:flex; width:100%")
                  v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogChangeCurency = false; selectedCurrencyInput = oldSelectedCurrency.value; oldSelectedCurrency = {value:"", text: ""}')
                    | No
                  v-btn(style="background:#1976D2;color:#fff; flex:1;margin:.3rem" text='' @click='handleChangeCurrency();changeCurency(); dialogChangeCurency = false')
                    | Yes
          
          v-dialog(v-model='dialogConfirmDelete' max-width='400')
            v-card
              <svg style="margin: 1rem 1rem 0rem 1rem;" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Delete outline" clip-path="url(#clip0_6670_35732)">
                <path id="Vector" d="M12 38.5C12 40.7 13.8 42.5 16 42.5H32C34.2 42.5 36 40.7 36 38.5V14.5H12V38.5ZM16 18.5H32V38.5H16V18.5ZM31 8.5L29 6.5H19L17 8.5H10V12.5H38V8.5H31Z" fill="#FF5252"/>
                </g>
                <defs>
                <clipPath id="clip0_6670_35732">
                <rect width="48" height="48" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
                </defs>
              </svg>
              v-card-title.text-h5
                | Delete Items
              v-card-text
                | Do you really want to delete this item?
              v-card-actions()
                v-spacer
                div(style="display:flex; width:100%")
                  v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogConfirmDelete = false')
                    | No
                  v-btn(style="background:#FF5252;color:#fff; flex:1;margin:.3rem" text='' @click='deleteItem(); dialogConfirmDelete = false')
                    | Yes
          
          // Only render payment details if allReady
          template(v-if="allReady")
            v-card(style="box-shadow: none")
              h2.mb-1 Payment Details
                span.color-red *
              h4(style="margin-bottom:.4rem") Currency
              v-autocomplete(
                id="imPayCurrencyBox"
                @change="handleChangeCurrency",
                v-model="selectedCurrencyInput",
                dense,
                :items="currencyBox",
                label="Select an item",
                outlined="",
                single-line="",
                hide-details=""
              )

              div(style="display: flex; width: 100%; padding: 1rem 0")
                div(style="flex: 0 1 47%; margin-right: 1rem; width: 40px",)
                  h4(style="margin-bottom:.4rem") Item Name
                  v-text-field(
                    v-model="addItemName",
                    id="imPayAddItemName"
                    label="Item Name",
                    :maxlength=50,
                    dense,
                    outlined="",
                    single-line="",
                    hide-details=""
                  )
                div(style=style="flex: 0 1 47%; margin-right: 1rem; width: 40px; ",)
                  h4(style="margin-bottom:.4rem") Amount Price
                  money(
                    id="imPayAddItemPrice"
                    :maxlength="selectedCurrency.value =='IDR' ? 19: 18",
                    style="width: 100%; height: 61%;border-radius: 5px; padding-left: 0.5rem; border: 1px solid #9e9e9e;"
                    v-model.number="addItemPrice" 
                    v-bind="currencyConfigs[selectedCurrency.value]"
                    :disabled="formDisabled"
                  )
                v-btn.ml-2.white--text(id="imPayAddItemBtn" style="margin-top: auto; margin-bottom: 4px;" color="primary", @click="addNew")
                  v-icon(dark="") add
                  | Add
            
            v-data-table.elevation-1(
              id="dtbl"
              style="border: 1px solid rgb(222 217 217)" 
              :headers="headers",
              :items="paymentItems",
              fixed-header="",
              height="100%",
              hide-default-footer,
              :items-per-page="-1",
              :header-props="headerProps"
            )
              template(v-slot:item.name="{ item }")
                input(
                  style="border:none; outline:none; border-bottom: solid 3px blue; width:100%"
                  v-model="editedItem.name",
                  :hide-details="true",
                  maxLength=40,
                  dense="",
                  single-line="",
                  :autofocus="true",
                  v-if="item.id === editedItem.id"
                )
                span(v-else="") {{ item.name }}
              template(v-slot:item.amount="{ item }")
                money(
                  v-bind="getMoneyFormat(selectedCurrency.value)"
                  v-model.number="editedItem.amount",
                  :maxlength="selectedCurrency.value =='IDR' ? 23: 22",
                  :hide-details="true",
                  style="border:none; outline:none; border-bottom: solid 3px blue; width:90%"
                  dense="",
                  single-line="",
                  v-if="item.id === editedItem.id"
                  :disabled="formDisabled"
                )
                money(v-else v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model.number="item.amount") {{ item.amount }}
              template(v-slot:item.actions="{ item }")
                div(v-if="item.id === editedItem.id")
                  v-icon.mr-3(color="red", @click="close")
                    | close
                  v-icon(color="green", @click="save")
                    | save
                div(v-else="")
                  v-icon.mr-3(color="green", @click="editItem(item)")
                    | edit
                  v-icon(color="red", @click="dialogConfirmDelete = true; tempDeleteItem = item")
                    | delete
              template(slot="body.append")
                tr(v-if="paymentItems.length > 0" class="")
                  th(style="font-size:14px !important" class="title") Total Amount
                  th(style="font-size:14px !important" class="title")
                    money(v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model="totalPayment")
                  th(style="font-size:14px !important" class="title")
              template(v-slot:no-data="")
                div(style="margin :2rem")
                  h2 No items
                  h4 Please input and add item.
            v-toolbar(
              id="ThisToolbar"
              color="white",
              style="width: 100%; padding: 0 !important; box-shadow: none !important"
            )
          v-btn(depressed, large, id="imPayPage2Cancel" style="background-color: #f5f5f5;margin: 0.3rem;" text="" @click="$router.push('/my-request')") Cancel
          v-btn(depressed, large, id="imPayPage2Back" style="margin: 0.3rem; background: #607D8B; color:#fff", @click="e1 = 1") Back
          v-btn(depressed, large, id="imPayPage2Next" style="margin: 0.3rem" :disabled="form2Validation" color="primary", @click="e1 = 3; getMyBUMember();") Next
        v-stepper-content(step="3" style="padding:0")
          v-alert(
            style="margin:0"
            dismissible,
            color="red",
            dark,
            v-model="alert",
            transition="scale-transition"
          ) {{ alertMessage }}
          v-card(style="box-shadow: none; padding:1rem 1rem; border-top: 1px solid #adadad;")
            div(style="display: flex;width: 100%;justify-content: space-between;")
              div(v-if="( this.$store.state.dataEditRequest.imStatus == 1 )" style="padding:0 1rem; flex:1")
                v-autocomplete(
                  id="imPayInternalApprover"
                  style="padding: 0; margin:.5",
                  label="Approver",
                  :items="myBuMember",
                  v-model="approver",
                  placeholder="Select",
                  chips,
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(1)"
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                v-autocomplete(
                  :search-input.sync='searchCrossBU' 
                  id="imPayCrossApprover"
                  style="padding: 0; margin:.5",
                  label="Approver Cross BU",
                  v-model="approver",
                  chips
                  color="blue-grey lighten-2"
                  :items="crosBuMember",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data"
                  multiple
                  :append-icon="'close'"
                  @click:append="handleClearEvent(2)"
                  hide-no-data='' 
                  hint="Enter at least 3 letters to find out the search results."
                  return-object=true
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                v-autocomplete(
                  style="padding: 0; margin:.5",
                  id="imPayInternalCC"
                  label="CC",
                  v-model="tembusan",
                  :items="getCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(3)"
                  @change="removeCc()"
                  hide-details
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")

                small(style="color: #F08703;" ) *CC can only view memo, cannot approve memo.

                v-autocomplete(
                  :search-input.sync='searchCrossCC',
                  id="imPayCrossCC"
                  style="padding: 0; margin:.5",
                  label="Cross CC",
                  v-model="tembusan",
                  :items="getCrossCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(4)",
                  hide-no-data='',
                  @change="removeCc()",
                  hint="Enter at least 3 letters to find out the search results.",
                  return-object=true
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")
                v-flex.autocomplete-result.d-flex.flex-row.align-center.mt-3
                  v-checkbox.mr-2(
                    id="imPayCBHideTTL"
                    v-model="disabledHidetitle",
                    label="Hide Title",
                    :disabled="useAlias"
                  )
                  v-checkbox(id="imPayCBUseAls" v-model="useAlias" label="Use Alias Name")
                  v-checkbox(id="imPayCBShowLogo" style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")

                p(style="color: #F08703; font-size: 12px" class="mb-0" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.
              div(style="padding:0 1rem; flex:1")
                div(v-if="( this.$store.state.dataEditRequest.imStatus == 1 )").badge-approval.d-flex.mt-0() 
                  .mr-3
                    img(src="../assets/icon/ic_tips.svg")
                  .align-self-center
                    i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

                template
                  .mb-5.mt-5
                    p.title.mb-1 Approver
                    ol.autocomplete-results(v-show="approver")
                      draggable.list-group(
                        :list="approver",
                        :disabled="this.tempDataPaymentL.imStatus != 1",
                        ghost-class="ghost",
                        @start="draggings = true",
                        @end="draggings = false"
                      )
                        li.autocomplete-result(
                          v-for="(requestor, i) in approver"
                          :key="requestor.id"
                        )
                          v-chip.list-group-item.ma-1(v-if="tempDataPaymentL.imStatus == 1" @click:close="removeApp(requestor)",x-large,close,label) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                          v-chip.ma-1(v-else, label, x-large) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                template
                  .mb-5.mt-5
                  p.title.mb-1 CC
                  ol.autocomplete-results(v-show="tembusan")
                    li.autocomplete-result(
                      v-for="(requestor, i) in tembusan",
                      key="i"
                    )
                      v-chip.ma-1(v-if="tempDataPaymentL.imStatus == 1" @click:close="removeCc(requestor)" label ,x-large ,close) 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                      v-chip.ma-1(v-else, label, x-large) 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
          v-btn(id="imPayPage3Cancel" style="background-color: #f5f5f5;margin-left: 1.5rem" depressed, large, text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPayPage3Back" style="margin-left: 0.5rem" dark, color="blue-grey", depressed, large, @click="e1 = 2") Back
          v-btn.ml-2(
            id="imPayPage3btnDraft"
            v-if="this.$store.state.dataEditRequest.imStatus == 1"
            color="info",
            depressed,
            large,
            :disabled="approver.length == 0 || isLoading",
            @click="submitMemo(1)"
          )
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          //- WithdrawDialog( :disableds="isLoading", small class='mr-2' v-if="this.$store.state.dataEditRequest.imStatus == 3 && $route.name == 'Edit Memo Payment' && this.$store.state.dataUsers._id == this.$store.state.dataEditRequest.imUser._id" :imId="this.$store.state.dataEditRequest._id" :type="this.$store.state.dataEditRequest.imType" creator)
          v-btn(
            id="imPayPage3btnSubmit"
            style="margin: 0.5rem" 
            depressed,
            large,
            color="success",
            :disabled="approver.length == 0 || isLoading",
            @click="submitMemo(2)"
          ) 
            v-icon send
            | &nbsp; Submit Request
          
</template>

<script>
import axios from "axios";
//- import * as masterBank from "../data/bank.json";
import draggable from "vuedraggable";
import WithdrawDialog from "@/components/WithdrawWizard.vue";
export default {
  components: {
    draggable,
    WithdrawDialog,
  },
  data() {
    return {
      useLogo: true,
      errorActiveUserMsg: "",
      dialogInactiveApprover: false,
      dialogInactiveBank: false,
      dialogChangeCurency: false,
      dialogConfirmDelete: false,
      tempDeleteItem: null,
      pickerStyle: false,
      fileName: [],
      file: [],
      data_memo: null,
      data_lampiran: [],
      uploadAlert: false,
      clearFile: false,
      currencyConfigs: {
      },
      moneyAdd: {
        decimal: ",",
        thousands: ".",
        precision: 0,
        masked: false,
      },
      moneyUSDAdd: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false,
      },
      isLoading: false,
      isCopy: this.$route.fullPath.includes("copyIM") ? true : false,
      btnLoader: false,
      masterBank: [],
      searchCrossCC: "",
      searchCrossBU: "",
      e1: 1,
      alertMessage: "",
      alert: false,
      draggings: false,
      approver: [],
      tembusan: [],
      myBuMember: [],
      crosBuMember: [],
      listCrossCC: [],
      totalPayment: 0,
      myBuList: [],
      imPayDataSelectedBU: "",
      imPayDataTujuan: "",
      imPayDataPayTo: "",
      imPayDataBankName: "",
      imPayDataBankNo: "",
      imPayDataInvoiceNo: "",
      imPayDataInvoiceDate: "",
      imPayDataTaxNo: "",
      imPayDataPurpose: "",
      addItemName: "",
      addItemPrice: null,
      select: "",
      items: ["BU01", "BU02", "BU03"],
      search: "",
      selectedCurrency: { value: "IDR", text: "IDR" },
      selectedCurrencyInput:{"text":"IDR","value":"IDR"},
      oldSelectedCurrency: { value: "", text: "" },
      headerProps: {
        class: "custom-header",
      },
      headers: [
        {
          text: "Items",
          value: "name",
          sortable: false,
          width: "50%",
        },
        {
          text: "",
          value: "amount",
          sortable: false,
          width: "40%",
        },
        { text: "", value: "actions", sortable: false, width: "10%" },
      ],
      paymentItems: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: "",
        amount: 0,
      },
      defaultItem: {
        id: 0,
        name: "New Item",
        amount: 0,
      },
      useAlias: true,
      hideTitle: [],
      disabledHidetitle: false,
      tempDataPaymentL: null,
      prevSelectedBUID: null,
      max_total_approver: 0,
      use_setting_max_approver: true,
      configsLoaded: false, // Add loading state for currency configs
      dataLoaded: false, // new flag for all data ready
    };
  },

  computed: {

    currencyBox() {
      return Object.keys(this.currencyConfigs).map(currency => ({
        text: currency,
        value: currency
      }));
    },
    form1Validation() {
      //- return false
      if (
        this.imPayDataSelectedBU &&
        this.imPayDataSelectedBU &&
        this.imPayDataPayTo &&
        this.imPayDataBankName &&
        this.imPayDataBankNo &&
        this.imPayDataPurpose &&
        this.imPayDataTujuan
      )
        return false;
      return true;
    },
    form2Validation() {
      //- return false
      if (this.paymentItems.length > 0) return false;
      return true;
    },
    getCCData() {
      let result = [];
      const tempDataPaymentCC = this.myBuMember;
      for (let i in tempDataPaymentCC) {
        tempDataPaymentCC[i].isCros = false;
        result.push(tempDataPaymentCC[i]);
      }
      return result;
    },

    getCrossCCData() {
      let result = [];
      const tempDataPaymentCC = this.listCrossCC;
      for (let i in tempDataPaymentCC) {
        tempDataPaymentCC[i].isCros = true;
        result.push(tempDataPaymentCC[i]);
      }

      return result;
    },
    formDisabled() {
      // Disable form if configs not loaded
      return !this.allReady;
    },
    allReady() {
      return this.configsLoaded && this.dataLoaded;
    },
  },
  methods: {

    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
        this.configsLoaded = true; // Set loaded flag
      } catch (error) {
        // Fallback to default configurations...
        this.configsLoaded = true; // Still allow form if fallback
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.text.toLowerCase();
      const textTwo = item.alias.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    trigerChange(e) {
      this.approver = []
      this.myBuMember = []
      this.crosBuMember = []
      this.tembusan = []
      this.listCrossCC = []
      if (this.use_setting_max_approver) {
        let token = localStorage.getItem("token");
        let buId;
        if (this.imPayDataSelectedBU && typeof this.imPayDataSelectedBU === 'string') {
          const parts = this.imPayDataSelectedBU.split("-");
          buId = parts.length > 1 ? parts[1] : this.imPayDataSelectedBU;
        } else if (this.imPayDataSelectedBU) {
          buId = this.imPayDataSelectedBU.buid || this.imPayDataSelectedBU;
        }
        if (!buId || buId === "undefined" || buId === "null") return;
        axios
          .get(
            process.env.VUE_APP_API +
              `/business-unit/detail/${buId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            this.max_total_approver = res.data.max_approver ? res.data.max_approver : 0;
          })
          .catch((err) => {
            this.$toasted.error(err, { icon: "error" });
          })
      }
    },
    handleClearEvent(al) {
      let data1 = [];
      let data2 = [];
      let result = [];
      if (al == 1) {
        data1 = this.approver;
        data2 = this.myBuMember;
      } else if (al == 2) {
        data1 = this.approver;
        data2 = this.crosBuMember;
      } else if (al == 3) {
        data1 = this.tembusan;
        data2 = this.getCCData;
      } else if (al == 4) {
        data1 = this.tembusan;
        data2 = this.getCrossCCData;
      }

      for (let i in data1) {
        let isFound = false;
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true;
        }
        if (!isFound) result.push(data1[i]);
      }

      if (al == 1 || al == 2) this.approver = result;
      else this.tembusan = result;
    },
    disablePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData("text/plain");
      if (/^[^a-zA-Z]*$/.test(pastedData)) return;
      event.preventDefault();
    },
    handleChangeCurrency() {
      // Always clear values on currency change to prevent misparsing
      this.addItemName = "";
      this.addItemPrice = null;
      // Normalize all paymentItems amounts to numbers using the new config
      const config = this.currencyConfigs[this.selectedCurrency.value] || {thousands: ',', decimal: '.'};
      this.paymentItems = this.paymentItems.map(item => ({
        ...item,
        amount: this.parseCurrencyString(item.amount, config)
      }));
      // If editing, normalize editedItem.amount
      if (this.editedItem && typeof this.editedItem.amount === 'string') {
        this.editedItem.amount = this.parseCurrencyString(this.editedItem.amount, config);
      }
      if (this.paymentItems.length > 0) this.dialogChangeCurency = true;
      else return;
    },
    numberOnly(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sumField(key) {
      const res = this.paymentItems.reduce((a, b) => +a + +(b[key] || 0), 0);
      this.totalPayment = res;
      return res;
    },
    removeCc(item) {
      let result = [];
      for (const key in this.tembusan)
        if (this.tembusan[key].id != item.id) result.push(this.tembusan[key]);
      this.tembusan = result;
    },
    removeApp(item) {
      let result = [];
      for (const key in this.approver)
        if (this.approver[key].id != item.id) result.push(this.approver[key]);
      this.approver = result;
    },
    countTotal() {
      let ttl = 0;
      for (let i in this.paymentItems) ttl += +this.paymentItems[i].amount;
      this.totalPayment = ttl;
    },
    editItem(item) {
      this.editedIndex = this.paymentItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // Normalize editedItem.amount to number
      const config = this.currencyConfigs[this.selectedCurrency.value] || {thousands: ',', decimal: '.'};
      this.editedItem.amount = this.parseCurrencyString(this.editedItem.amount, config);
    },
    deleteItem() {
      const index = this.paymentItems.indexOf(this.tempDeleteItem);
      this.paymentItems.splice(index, 1);
      this.countTotal();
      this.tempDeleteItem = null;
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },addNew() {
      const names = Object.keys(this.currencyConfigs);
      if (!names.includes(this.selectedCurrency.value)) {
        alert(`Pilih currency dari: ${names.join(", ")}`);
        return;
      }

      // Cast & validasi harga
      const config = this.currencyConfigs[this.selectedCurrency.value] || {thousands: ',', decimal: '.'};
      const price = this.parseCurrencyString(this.addItemPrice, config);
      if (!this.addItemName || isNaN(price)) {
        alert("Nama atau harga tidak valid");
        return;
      }

      // Buat objek baru dengan angka murni
      const addObj = {
        name: this.addItemName,
        amount: price,
        currency: this.selectedCurrency.value,
      };

      // Masukkan ke depan, lalu recalc ID
      this.paymentItems.unshift(addObj);
      this.paymentItems.forEach((item, idx) => {
        item.id = idx + 1;
      });

      this.editItem(addObj);
      this.save();

      // Reset form
      this.addItemPrice = 0;
      this.addItemName = "";
    },
    addFile() {
      //this.$refs.fileadd.click();
      for (const key in this.$refs.fileadd.files) {
        if (this.$refs.fileadd.files[key].size != undefined) {
          if (this.$refs.fileadd.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.fileadd.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.fileadd.files[key]);
              this.fileName.push(this.$refs.fileadd.files[key].name);
            }
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    uploadLampiran() {
      if (this.edit) {
        if (this.file.length < 0) {
          this.fileName = [];
        }
      }
      this.file = [];

      for (const key in this.$refs.file.files) {
        if (this.$refs.file.files[key].size != undefined) {
          if (this.$refs.file.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.file.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.file.files[key]);
              this.fileName.push(this.$refs.file.files[key].name);
            }

            //- this.file[key] = this.$refs.file.files[key];
            //- this.fileName[key] = this.$refs.file.files[key].name;
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    removeLampiran(name, index) {
      if (
        this.fileName[index].url == name.url &&
        this.fileName[index].url != undefined
      ) {
        this.fileName.splice(this.fileName.indexOf(name), 1);
      } else {
        this.file.splice(index, 1);
        for (var i = 0; i < this.fileName.length; i++) {
          if (this.fileName[i] === name) {
            this.fileName.splice(i, 1);
          }
        }
      }

      this.$refs.fileadd.value = "";
      if (this.fileName.length == 0 && this.file.length == 0) {
        this.clearFile = true;
        this.tempDataPaymentL.imFileLampiran = [];
      }

      this.tempDataPaymentL.imFileLampiran = [];
      this.fileName.forEach((item) => {
        if (item.url != null) {
          this.tempDataPaymentL.imFileLampiran.push(item);
        }
      });

      //- console.log(this.fileName)
    },
    UploadAttachtment: async function (data) {
      let formData = new FormData();
      formData.append("attachment", data);
      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/memo/upload-file`,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };
      await axios(config)
        .then((res) => {
          //this.data_memo.attachment.push(res.data.data)
          this.data_lampiran.push(res.data.data);
          //this.data_memo.attachment = res.data.data
        })
        .catch((err) => {
          let err_msg = err.response.data.message;
          this.$toasted.error(err_msg, { icon: "error" });
        });
    },
    save() {
      if (!this.editedItem.amount || !this.editedItem.name) return;
      if (this.editedIndex > -1) {
        Object.assign(this.paymentItems[this.editedIndex], this.editedItem);
      }
      this.countTotal();
      this.close();
    },
    changeCurency() {
      //- if (this.paymentItems) for(let i in this.paymentItems)this.paymentItems[i].currency = this.selectedCurrency.value
      this.paymentItems = [];
    },
    async getMyActiveBU() {
      try {
        const token = localStorage.getItem("token");
        const userId = this.$store.state.dataUsers.user;
        if (userId) {
          const reqDataBU = await axios.get(
            `${process.env.VUE_APP_API}/users/active/bu/${userId._id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const listBU = reqDataBU.data.data;
          for (let i in listBU) {
            if (listBU.length == 1)
              listBU[i].label = `${listBU[i].business_unit.bu_name}`;
            else
              listBU[i].label = `${listBU[i].business_unit.bu_name} as ${
                listBU[i].position ? listBU[i].position : ""
              }`;
            listBU[i].value = `${listBU[i].id}-${listBU[i].business_unit.id}`;
          }
          this.myBuList = listBU;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getCrossBUMember() {
      try {
        const token = localStorage.getItem("token");
        this.crosBuMember = [];
        const reqDataCrossBUMember = await axios.get(
          `${process.env.VUE_APP_API}/users/busines-unit/${
            this.imPayDataSelectedBU.split("-")[0]
              ? this.imPayDataSelectedBU.split("-")[0]
              : this.imPayDataSelectedBU
          }`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dataCrossBUMember = reqDataCrossBUMember.data.data;
        for (let i in dataCrossBUMember)
          if (
            dataCrossBUMember[i].email != this.$store.state.dataUsers.user.email
          )
            for (let j in this.approver)
              if (this.approver[i].email == dataCrossBUMember[i].email)
                this.crosBuMember.push(dataCrossBUMember[i]);
      } catch (e) {
        console.log(e);
      }
    },
    async getMyBUMember() {
      try {
        const token = localStorage.getItem("token");
        const reqDataMyBUMember = await axios.get(
          `${process.env.VUE_APP_API}/users/bu/list/${
            this.imPayDataSelectedBU.split("-")[1]
              ? this.imPayDataSelectedBU.split("-")[1]
              : this.imPayDataSelectedBU
          }`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dataMyBUMember = reqDataMyBUMember.data.data;
        this.myBuMember = dataMyBUMember;
      } catch (e) {
        console.log(e);
      }
    },
    async submitMemo(act) {
      this.isLoading = true;
      let isNeedReview = this.status == 3 ? true : false;
      let isReSubmited = 0;
      try {
        const reqCreatorData = await axios.get(
          `${process.env.VUE_APP_API}/memo/creator/${
            this.imPayDataSelectedBU.split("-")[0]
              ? this.imPayDataSelectedBU.split("-")[0]
              : this.imPayDataSelectedBU
          }`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );
        let creator_data = reqCreatorData.data.data;

        let buIdForDetail;
        if (this.imPayDataSelectedBU && typeof this.imPayDataSelectedBU === 'string') {
          const parts = this.imPayDataSelectedBU.split("-");
          buIdForDetail = parts.length > 1 ? parts[1] : this.imPayDataSelectedBU;
        } else if (this.imPayDataSelectedBU) {
          buIdForDetail = this.imPayDataSelectedBU.buid || this.imPayDataSelectedBU;
        }
        if (!buIdForDetail || buIdForDetail === "undefined" || buIdForDetail === "null") {
          this.$toasted.error("Business Unit is required", { icon: "error" });
          this.isLoading = false;
          return;
        }
        const chosenBUDetail = await axios.get(
          `${process.env.VUE_APP_API}/business-unit/detail/${buIdForDetail}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );
        chosenBUDetail.data.id = chosenBUDetail.data._id;
        delete chosenBUDetail.data._id;

        //- CONTAIN INTERNAL AND CROSS BU APPV
        const approvers = [];

        if (this.tembusan) {
          for (const item of this.tembusan) {
            if (!item.is_active) {
              this.errorActiveUserMsg =
                this.tempDataPaymentL.imStatus == 3
                  ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
                  : "Sorry, there is inactive account. Please close or change new account.";
              this.dialogInactiveApprover = true;
              this.isLoading = false;
              return;
            }
          }
        }

        for (const item of this.approver) {
          if (!item.is_active) {
            this.errorActiveUserMsg =
              this.tempDataPaymentL.imStatus == 3
                ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
                : "Sorry, there is inactive account. Please close or change new account.";
            this.dialogInactiveApprover = true;
            this.isLoading = false;
            return;
          }
          if (typeof item.comment === "undefined") {
            this.$set(item, "comment", null);
          }

          if (this.useAlias) {
            this.$set(item, "name", item.name);
          }

          this.$set(item, "postAs", "approver");

          approvers.push(item);
        }

        let newApp = approvers;
        if (act == 2 && newApp[0].status == null) newApp[0].status = 9;
        else if (this.tempDataPaymentL.imStatus > 1) {
          var imWf = [...approvers];
          newApp = [];
          var statusBefore = 7;

          for (const item of imWf) {
            if (
              (item.status == 9 || item.status == 3) &&
              this.$store.state.dataEditRequest.imUser.id !=
                this.$store.state.dataUsers.user._id
            ) {
              item.status = 7;
              item.comment = "";
              item.date = new Date();
            }
            if (item.status == null && statusBefore == 7) item.status = 9;
            if (item.status == 6 && statusBefore == 7) item.status = 9;
            statusBefore = item.status;
            newApp.push(item);
          }

          if (isNeedReview && newApp[0].status == 9) {
            isReSubmited = 1;
          }
        }

        let formData = new FormData();

        let isRoleCreator = false;
        let tempDataImUser = this.tempDataPaymentL.imUser;
        let selectedBUs = this.imPayDataSelectedBU.split("-")[0]
          ? this.imPayDataSelectedBU.split("-")[0]
          : this.imPayDataSelectedBU;
        for (let dataUserBU of this.$store.state.dataUsers.user.bu) {
          if (dataUserBU.id == this.tempDataPaymentL.imUser.id) {
            isRoleCreator = true;
          }

          if (dataUserBU.id == selectedBUs) {
            tempDataImUser = dataUserBU;
            tempDataImUser.name = this.$store.state.dataUsers.user.full_name;
            tempDataImUser.label = dataUserBU.business_unit.bu_name;
            tempDataImUser.value = dataUserBU.business_unit.id;
          }
        }

        if (this.$store.state.dataEditRequest.imStatus == 1) {
          tempDataImUser = creator_data;
          tempDataImUser.label = creator_data.business_unit.bu_name;
          tempDataImUser.value = creator_data.business_unit.id;
        }

        if (!isRoleCreator) {
          formData.append("isApproverEdit", 1);
        } else {
          formData.append("isApproverEdit", 0);
          formData.append("userId", this.$store.state.dataUsers.user._id);
        }
        formData.append("userId", this.$store.state.dataUsers.user._id);
        //- formData.append("user", JSON.stringify(creator_data));
        formData.append("imType", 6);
        //- formData.append("status", this.statusEdit);
        formData.append("imTujuan", this.imPayDataTujuan.replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,''));
        formData.append("imStatus", act);

        if (this.$store.state.dataEditRequest.imStatus == 1)
          formData.append(
            "imOrganization",
            JSON.stringify(chosenBUDetail.data)
          );
        else
          formData.append(
            "imOrganization",
            JSON.stringify(this.$store.state.dataEditRequest.imOrganization)
          );

        formData.append("imTargetDate", new Date().toISOString().substr(0, 10));
        formData.append("imUseAlias", this.useAlias ? true : false);
        formData.append("imHideTitle", this.disabledHidetitle ? true : false);
        formData.append("imUseLogo", this.useLogo ? true : false);
        if (act == 2 && newApp[0].status == null) newApp[0].status = 9;
        formData.append("imApprover", JSON.stringify(newApp));
        formData.append("imCC", JSON.stringify(this.tembusan));
        formData.append("imGroup", "nongroup");
        formData.append(
          "imPerihal",
          this.imPayDataPurpose.replaceAll(`"`, `'`).replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,'')
        );
        formData.append("imPayDataPayTo", this.imPayDataPayTo);
        formData.append("imPayDataBankName", this.imPayDataBankName);
        formData.append("imPayDataBankNo", this.imPayDataBankNo);
        formData.append("imPayDataInvoiceNo", this.imPayDataInvoiceNo);
        formData.append("imPayDataInvoiceDate", this.imPayDataInvoiceDate);
        formData.append("imPayDataTaxNo", this.imPayDataTaxNo);
        formData.append(
          "imPaymentData",
          JSON.stringify({
            paymentCurrency: this.selectedCurrency,
            paymentItems: this.paymentItems,
            paymentTotal: this.totalPayment,
          })
        );
        formData.append("imUser", JSON.stringify(tempDataImUser));
        formData.append("isReSubmited", isReSubmited);
        if (this.$store.state.dataEditRequest.imStatus == 3) {
          formData.append("isNeedReview", 1);
        } else {
          formData.append("isNeedReview", 0);
        }
        if (
          (this.file.length > 0 && this.file[0].name) ||
          (this.fileName.length > 0 && this.fileName[0].name)
        ) {
          for (const key in this.file) {
            await this.UploadAttachtment(this.file[key]);
          }

          this.data_memo = this.data_lampiran;

          if (this.tempDataPaymentL.imFileLampiran != null) {
            for (const key in this.data_memo) {
              this.tempDataPaymentL.imFileLampiran.push(this.data_memo[key]);
            }
          } else {
            this.tempDataPaymentL.imFileLampiran = this.data_memo;
          }

          let rst = [];
          for (let i in this.tempDataPaymentL.imFileLampiran)
            if (this.tempDataPaymentL.imFileLampiran[i].url)
              rst.push(this.tempDataPaymentL.imFileLampiran[i]);

          formData.append("imFileLampiran", JSON.stringify(rst));
          formData.append("imFilelength", this.file.length);
        } else {
          formData.append("imFileLampiran", JSON.stringify([]));
          formData.append("imFilelength", 0);
        }

        //- const configSubmitMemoReqEdit = {
        //-   method: "post",
        //-   url: process.env.VUE_APP_API_OLD + `/api/requests`,
        //-   headers: { "Content-Type": "multipart/form-data" },
        //-   data: formData,
        //- };

        if (this.$store.state.dataEditRequest.imStatus == 1) {
          const creatorID = this.$store.state.dataEditRequest.imUser.id;
          const listLoginUserBU = this.$store.state.dataUsers.user.bu;
          //- VALIDATE LOGIN USER HAVE SAME ID AS CREATOR MEMO
          for (let i in listLoginUserBU)
            if (listLoginUserBU[i].id == creatorID)
              formData.append("imDate", new Date().toISOString());
        }
        if (this.tempDataPaymentL.imStatus == 3)
          formData.append(
            "person",
            JSON.stringify(
              this.tempDataPaymentL.imReturn[
                this.tempDataPaymentL.imReturn.length - 1
              ]
            )
          );
        if (this.tempDataPaymentL.imStatus == 1)
          formData.append("draft", "draft");
        // disabkled THIS
        const configSubmitMemoReqEdit = {
          method: "put",
          url: `${process.env.VUE_APP_API_OLD}/api/requests/${this.$store.state.dataEditRequest.imNo}/${this.$store.state.dataUsers.user._id}`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };

        const submitMemoReq = await axios(configSubmitMemoReqEdit);

        if (submitMemoReq.status == 200) {
          this.isLoading = false;
          act == 1
            ? this.$toasted.info("Memo has been successfully saved to draft", {
                icon: "save",
              })
            : this.$toasted.success(
                "Success, the memo was successfully generated and sent to the approver.",
                { icon: "check_circle" }
              );
          this.$router.push("/my-request").then(() => {
            location.reload(); // Reload the page after navigation
          });
        }
      } catch (e) {
        console.log(e.response);
        let error = e.response.data.message || "Err";
        if (error != "Err") this.$toasted.error(error, { icon: "error" });
        else this.$toasted.error(error, { icon: "error" });
        if (error.includes("Failed")) this.$router.push("/my-request");
      } finally {
        this.isLoading = false;
      }
    },
    setUseAlias() {
      if (this.useAlias) {
        this.disabledHidetitle = true;
      }
    },
    getMoneyFormat(currency) {
      return this.currencyConfigs[currency] || this.currencyConfigs.USD;
    },
    // Utility: robustly parse a currency string to a number
    parseCurrencyString(str, config) {
      if (typeof str === 'number') return str;
      if (!str) return 0;
      let s = String(str).replace(new RegExp('\\' + (config.thousands || ','), 'g'), '');
      if (config.decimal && config.decimal !== '.') {
        s = s.replace(new RegExp('\\' + config.decimal, 'g'), '.');
      }
      // Remove any non-numeric except . and -
      s = s.replace(/[^0-9.-]/g, '');
      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    },
  },

  watch: {
    selectedCurrencyInput(val){
      this.selectedCurrency = {"text":val,"value":val}
    },
    disabledHidetitle(val) {
      if (val) {
        for (const key in this.bod) {
          this.hideTitle.push(this.bod[key].id);
        }
      } else {
        this.hideTitle = [];
      }
    },

    useAlias(val) {
      if (val) {
        this.disabledHidetitle = true;
      } else if (this.disabledHidetitle == true && val == true) {
        this.disabledHidetitle = false;
        this.hideTitle = [];
      } else {
        this.hideTitle = [];
      }
    },
    async searchCrossCC(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
          const token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${process.env.VUE_APP_API}/users/busines-unit/${
              this.imPayDataSelectedBU.split("-")[1]
                ? this.imPayDataSelectedBU.split("-")[1]
                : this.imPayDataSelectedBU
            }?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const res = data.data;
          //- if (res.length != 0 ) this.listCrossCC = []
          for (let i in res)
            if (
              res[i].is_active &&
              res[i].name != this.$store.state.dataUsers.user.full_name
            )
              this.listCrossCC.push(res[i]);
        }
      } catch (e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
        }
      } finally {
      }
    },
    async searchCrossBU(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
          //- this.isLoading = true;
          const token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${process.env.VUE_APP_API}/users/busines-unit/${
              this.imPayDataSelectedBU.split("-")[1]
                ? this.imPayDataSelectedBU.split("-")[1]
                : this.imPayDataSelectedBU
            }?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const res = data.data;
          //- if (res.length != 0 ) this.crosBuMember = []
          for (let i in res)
            if (
              res[i].is_active &&
              res[i].name != this.$store.state.dataUsers.user.full_name
            )
              this.crosBuMember.push(res[i]);
        }
      } catch (e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
        }
      } finally {
        //- this.isLoading = false
      }
    },
    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        let approver = this.approver[this.approver.length - 1];
        let isBreak = false;

        if (this.use_setting_max_approver && this.max_total_approver !== 0 && this.approver.length > this.max_total_approver) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        } else {
          for (const iterator of this.tembusan) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
        }
      }
    },
    tembusan() {
      if (this.tembusan.length > 0) {
        let tembusan = this.tembusan[this.tembusan.length - 1];
        let isBreak = false;

        for (const iterator of this.approver) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            isBreak = true;
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
      }
    },
    selectedCurrency(val, oldVal) {
      if (val !== oldVal) {
        this.oldSelectedCurrency = oldVal;
      }
    },
  },

  created() {
    
    if (!sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload(true);
    }
    this.fetchCurrencyConfigs()

    setTimeout(async () => {
      let tempDataPayment = this.$store.state.dataEditRequest;
      for(let x = 0;x<10;x++){
      if(!tempDataPayment.imStatus){
          await new Promise(resolve => setTimeout(resolve, 1000));
          tempDataPayment = this.$store.state.dataEditRequest;
        }else{
          break
        }
      }
      //marking error
      try {
        //- PREVENT RUNING MEMO FROM BEING EDITED
        if (tempDataPayment.imStatus != 1 && tempDataPayment.imStatus != 3) {
          this.$toasted.error("Failed, memo has been submited", {
            icon: "error",
          });
          this.$router.push("/my-request");
        }

        //- NR CONDITION MAKE SURE THE 1 WHO OPEN IT IS ON LAST EL OF imReturn
        //- NOTES NR TO CREATOR, CREATOR NOT IN IMWORKFLOW, CREATOR IN imReturn DINT HAVE USER(CRED)ID, HENCE LOOP TROUGH user.bu
        if (tempDataPayment.imReturn) {
          const searchUserBUID =
            tempDataPayment.imReturn[tempDataPayment.imReturn.length - 1].id;
          const searchUserBUs = this.$store.state.dataUsers.user.bu;
          let flag = false;
          for (let i in searchUserBUs)
            if (searchUserBUs[i].id == searchUserBUID) flag = true;
          if (tempDataPayment.imStatus == 3 && !flag) {
            this.$toasted.error("Failed, memo has been submited", {
              icon: "error",
            });
            this.$router.push("/my-request");
          }
        }
      } catch (e) {
        console.log(e);
      }

      //- DRAFT CONDITION ONLY THE CREATOR CAN OPEN THE PAGE
      if (
        tempDataPayment.imStatus == 1 &&
        this.$store.state.dataUsers.user._id != tempDataPayment.userId
      ) {
        this.$toasted.error("Failed, memo has been submited", {
          icon: "error",
        });
        this.$router.push("/my-request");
      }

      this.tempDataPaymentL = this.$store.state.dataEditRequest;
      if (this.tempDataPaymentL.imStatus != 1) {
        this.tempDataPaymentL.imUser.label =
          this.tempDataPaymentL.imUser.business_unit.bu_name;
        this.tempDataPaymentL.imUser.value =
          this.tempDataPaymentL.imUser.business_unit.id;
        this.myBuList = this.tempDataPaymentL.imUser;
      } else await this.getMyActiveBU();

      let dataPayment;

      if (typeof tempDataPayment.imPaymentData == "object") {
        dataPayment = tempDataPayment.imPaymentData;
      } else {
        dataPayment = JSON.parse(tempDataPayment.imPaymentData);
      }

      tempDataPayment.imUser.label =
        tempDataPayment.imUser.business_unit.bu_name;
      tempDataPayment.imUser.value = tempDataPayment.imUser.business_unit.id;
      this.imPayDataSelectedBU = `${this.$store.state.dataEditRequest.imUser.id}`;
      this.prevSelectedBUID =
        this.$store.state.dataEditRequest.imUser.business_unit.id;
      this.imPayDataPayTo = tempDataPayment.imPayDataPayTo;

      this.imPayDataBankNo = tempDataPayment.imPayDataBankNo;
      this.imPayDataInvoiceNo = tempDataPayment.imPayDataInvoiceNo;
      this.imPayDataInvoiceDate = tempDataPayment.imPayDataInvoiceDate;
      this.imPayDataTaxNo = tempDataPayment.imPayDataTaxNo;
      this.imPayDataPurpose = tempDataPayment.imPerihal.replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,'');
      this.imPayDataTujuan = tempDataPayment.imTujuan.replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,'');
      this.selectedCurrency = dataPayment.paymentCurrency.value;
      this.selectedCurrencyInput = dataPayment.paymentCurrency.value;
      // Normalize all loaded paymentItems amounts to numbers
      const config = this.currencyConfigs[this.selectedCurrency.value] || {thousands: ',', decimal: '.'};
      this.paymentItems = dataPayment.paymentItems.map(item => ({
        ...item,
        amount: this.parseCurrencyString(item.amount, config)
      }));
      this.totalPayment = dataPayment.paymentTotal;
      this.useAlias = tempDataPayment.imUseAlias;
      this.disabledHidetitle = tempDataPayment.imHideTitle;
      let tempLampiran = [];
      for (let i in tempDataPayment.imFileLampiran)
        if (tempDataPayment.imFileLampiran[i].name)
          tempLampiran.push(tempDataPayment.imFileLampiran[i]);
      tempDataPayment.imFileLampiran = tempLampiran;
      this.fileName = tempDataPayment.imFileLampiran;
      this.useLogo =
        this.$store.state.dataEditRequest.imUseLogo == "false" ? false : true;
      let isPrevBankNameFound = false;
      for (let i in this.masterBank)
        if (this.masterBank[i].text == tempDataPayment.imPayDataBankName)
          isPrevBankNameFound = true;
      if (isPrevBankNameFound)
        this.imPayDataBankName = tempDataPayment.imPayDataBankName;
      else {
        this.imPayDataBankName = "";
        this.dialogInactiveBank = true;
      }

      //- this.tembusan = tempDataPayment.tembusan
      const tempAppv = JSON.parse(tempDataPayment.imApprover);
      const tempAppvWF = tempDataPayment.imWorkflow;
      for (let i in tempAppvWF) {
        if (this.isCopy) {
          tempAppvWF[i].status = null;
          tempAppvWF[i].comment = undefined;
          tempAppvWF[i].date = undefined;
          tempAppvWF[i].action = undefined;
        }
        if (
          tempAppv[i].isCros != false &&
          tempAppv[i].business_unit.id !=
            tempDataPayment.imUser.business_unit.id
        )
          this.crosBuMember.push(tempAppvWF[i]);
      }
      let buid = "";
      if (this.$store.state.dataEditRequest.imStatus == 1) {
        this.imPayDataSelectedBU = `${this.$store.state.dataEditRequest.imUser.id}-${this.$store.state.dataEditRequest.imUser.business_unit.id}`;
        buid = this.$store.state.dataEditRequest.imUser.business_unit.id;
      } else {
        this.imPayDataSelectedBU =
          this.$store.state.dataEditRequest.imOrganization.id;
        buid = this.imPayDataSelectedBU;
      }

      if (buid && buid !== "undefined" && buid !== "null") {
        const token = localStorage.getItem("token");
        const reqDataBU = await axios.get(`${process.env.VUE_APP_API}/business-unit/detail/${buid}`, { headers: { Authorization: `Bearer ${token}` }})
        if (
          new Date(this.$store.state.dataEditRequest.imDate) >=
          new Date(process.env.CUT_OFF_MAX_APPROVER)
        ) {
          this.max_total_approver = reqDataBU.data.max_approver ? reqDataBU.data.max_approver : 0;
        } else {
          this.use_setting_max_approver = false;
        }
      }

      this.approver = tempAppvWF;

      //- const tempCC =
      //- for(let i in tempAppv) if (tempAppv[i].isCros !== false) this.crosBuMember.push(tempAppv[i])
      this.tembusan = tempDataPayment.imCC;

      const allCC = this.$store.state.dataEditRequest.imCC;
      for (let i in allCC) if (allCC[i].isCros) this.listCrossCC.push(allCC[i]);
      this.setUseAlias();
      if (this.tempDataPaymentL.imStatus == 1) {
        let found = false;
        for (let i in this.myBuList)
          if (this.myBuList[i].value == this.imPayDataSelectedBU) {
            found = true;
            break;
          }
        if (!found) this.imPayDataSelectedBU = "";
      } else {
        if (this.imPayDataSelectedBU && this.imPayDataSelectedBU !== "undefined" && this.imPayDataSelectedBU !== "null") {
          const token = localStorage.getItem("token");
          const reqDataBU = await axios.get(
            `${process.env.VUE_APP_API}/business-unit/detail/${this.imPayDataSelectedBU}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          if (!reqDataBU.data.is_active) this.imPayDataSelectedBU = "";
        }
      }
      this.dataLoaded = true; // Set data loaded flag after all is ready
    }, 1000);
  },

  mounted: async function () {
    this.$store.dispatch("fetchDataEditRequests", this.$route.params.id);
    const listBankResp = await axios.get(
      `${process.env.VUE_APP_API_OLD}/api/list_bank`
    );
    this.masterBank = listBankResp.data || [];
    for (let i in this.masterBank) {
      this.masterBank[i].value = this.masterBank[i].text;
      if (!this.masterBank[i].alias)
        this.masterBank[i].alias = this.masterBank[i].text;
    }
  },
};
</script>
<style>
.IMP-group-form {
  display: flex;
}

.IMP-title-form {
  margin: auto;
}

#dtbl th {
  background-color: #f0f0f0 !important; /* Ganti dengan warna yang diinginkan */
  color: #333; /* Ganti dengan warna teks yang diinginkan */
}
#dtbl th span {
  font-weight: bold;
  font-size: 18px;
}

#ThisToolbar .v-toolbar__content {
  padding: 0px !important;
  box-shadow: none !important;
}

td .v-money {
  text-align: right;
  width: 90%;
}
th .v-money {
  text-align: right;
  width: 90%;
}
</style>
